import React from 'react';
import './Hero.css';
import { Typewriter } from 'react-simple-typewriter';

const Hero = () => {
  return (
    <section className="hero">
      {/* Background video */}
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src="/hero-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Tint overlay */}
      <div className="video-tint"></div>

      {/* Text overlay */}
      <div className="hero-overlay">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              <span className="static-text">BUILD&nbsp;</span>
              <span className="animated-text">
                <Typewriter
                  words={['FASTER', 'BETTER', 'SMARTER']}
                  loop
                  cursor
                  cursorStyle="|"
                  typeSpeed={80}
                  deleteSpeed={60}
                  delaySpeed={1500}
                />
              </span>
            </h1>
            <p>
              We provide Seamless Digital Acceleration by boosting engineering and design capabilities, improving processes, and delivering end-to-end digital products.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;